const ROLE_KEYS = [
  "ADMIN",
  "INSTITUTE_ADMIN",
  "FILE_DOWNLOAD",
  "FILE_UPLOAD",
  "NUMBER_ADD",
  "NUMBER_VERIFY",
  "API_ACCESS",
] as const;

export type PROJECT_ROLE = {
  key: (typeof ROLE_KEYS)[number];
  displayName: string;
  group: string;
};

export const ADMIN_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[0],
  displayName: "Sperrdatei Admin",
  group: "ADMINISTRATION",
};

export const INSTITUTE_ADMIN_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[1],
  displayName: "Institut verwalten",
  group: "INSTITUTE_ADMINISTRATION",
};

export const FILE_DOWNLOAD_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[2],
  displayName: "Download der Sperrdatei",
  group: "FILE",
};

export const FILE_UPLOAD_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[3],
  displayName: "Sperrnummern hochladen",
  group: "FILE",
};

export const NUMER_ADD_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[4],
  displayName: "Nummer hinzufügen",
  group: "NUMBER",
};

export const NUMBER_VERIFY_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[5],
  displayName: "Nummer prüfen",
  group: "NUMBER",
};

export const API_ACCESS_ROLE: PROJECT_ROLE = {
  key: ROLE_KEYS[6],
  displayName: "Technischer Nutzer",
  group: "API",
};

export const PROJECT_ROLES: PROJECT_ROLE[] = [
  ADMIN_ROLE,
  INSTITUTE_ADMIN_ROLE,
  FILE_DOWNLOAD_ROLE,
  FILE_UPLOAD_ROLE,
  NUMER_ADD_ROLE,
  NUMBER_VERIFY_ROLE,
  API_ACCESS_ROLE,
];

export const isProjectRoleKey = (
  value: string,
): value is (typeof ROLE_KEYS)[number] => {
  return ROLE_KEYS.some((roleKey) => roleKey === value);
};
